import { OnInit } from "@angular/core";
import { ListEntityModel, ParticipationState } from "app/interfaces";
var ParticipantCardComponent = /** @class */ (function () {
    function ParticipantCardComponent() {
        this.showEmail = true;
    }
    Object.defineProperty(ParticipantCardComponent.prototype, "state", {
        get: function () {
            return ParticipationState[this.participant.state];
        },
        enumerable: true,
        configurable: true
    });
    ParticipantCardComponent.prototype.ngOnInit = function () { };
    return ParticipantCardComponent;
}());
export { ParticipantCardComponent };
